import _slicedToArray from "/Users/lianzhaocheng/Downloads/workplace/bieyang/web/bybieyang-home/product-search/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { forwardRef, useImperativeHandle, useRef, useState, useCallback } from 'react';
import { mergeProps } from '../../utils/with-default-props';
import { renderToContainer } from '../../utils/render-to-container';
import Mask from '../mask';
import SafeArea from '../safe-area';
import { Slide } from './slide';
import { Slides } from './slides';
var classPrefix = "adm-image-viewer";
var defaultProps = {
  maxZoom: 3,
  getContainer: null,
  visible: false
};
export var ImageViewer = function ImageViewer(p) {
  var _a;

  var props = mergeProps(defaultProps, p);
  var node = React.createElement(Mask, {
    visible: props.visible,
    disableBodyScroll: false,
    opacity: 'thick',
    afterClose: props.afterClose
  }, React.createElement("div", {
    className: "".concat(classPrefix, "-content")
  }, props.image && React.createElement(Slide, {
    image: props.image,
    onTap: function onTap() {
      var _a;

      (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props);
    },
    maxZoom: props.maxZoom
  })), props.image && React.createElement("div", {
    className: "".concat(classPrefix, "-footer")
  }, (_a = props.renderFooter) === null || _a === void 0 ? void 0 : _a.call(props, props.image), React.createElement(SafeArea, {
    position: 'bottom'
  })));
  return renderToContainer(props.getContainer, node);
};
var multiDefaultProps = Object.assign(Object.assign({}, defaultProps), {
  defaultIndex: 0
});
export var MultiImageViewer = forwardRef(function (p, ref) {
  var _a;

  var props = mergeProps(multiDefaultProps, p);

  var _useState = useState(props.defaultIndex),
      _useState2 = _slicedToArray(_useState, 2),
      index = _useState2[0],
      setIndex = _useState2[1];

  var slidesRef = useRef(null);
  useImperativeHandle(ref, function () {
    return {
      swipeTo: function swipeTo(index, immediate) {
        var _a;

        setIndex(index);
        (_a = slidesRef.current) === null || _a === void 0 ? void 0 : _a.swipeTo(index, immediate);
      }
    };
  });
  var onSlideChange = useCallback(function (index) {
    var _a;

    setIndex(index);
    (_a = props.onIndexChange) === null || _a === void 0 ? void 0 : _a.call(props, index);
  }, [props.onIndexChange]);
  var node = React.createElement(Mask, {
    visible: props.visible,
    disableBodyScroll: false,
    opacity: 'thick',
    afterClose: props.afterClose
  }, React.createElement("div", {
    className: "".concat(classPrefix, "-content")
  }, props.images && React.createElement(Slides, {
    ref: slidesRef,
    defaultIndex: index,
    onIndexChange: onSlideChange,
    images: props.images,
    onTap: function onTap() {
      var _a;

      (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props);
    },
    maxZoom: props.maxZoom
  })), props.images && React.createElement("div", {
    className: "".concat(classPrefix, "-footer")
  }, (_a = props.renderFooter) === null || _a === void 0 ? void 0 : _a.call(props, props.images[index], index), React.createElement(SafeArea, {
    position: 'bottom'
  })));
  return renderToContainer(props.getContainer, node);
});